import React from 'react';
import { EightShell } from '../../components/graphs/EightShell';
import '../../features/dashboards/RowingArcPrototype.css';

const RowerSidePrototypePage: React.FC = () => {
  return (
    <div className="arc-page-wrapper">
      <div className="arc-page">
        <EightShell />
      </div>
    </div>
  );
};

export default RowerSidePrototypePage;
